import Embed from 'quill/blots/embed';

class Divider extends Embed {
  static blotName = 'divider';
  static tagName = 'hr';
}

export default Divider;
